'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { AlertTriangle } from 'lucide-react';
interface DriveCheckErrorCardProps {
  onRetry: () => void;
}
function DriveCheckErrorCard(t0) {
  const $ = _c(4);
  const {
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-destructive/15 text-destructive flex size-12 items-center justify-center rounded-full"><AlertTriangle className="size-5" aria-hidden="true" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-2"><h2 className="text-2xl font-semibold tracking-tight">We couldn't check your drives</h2><p className="text-muted-foreground max-w-md text-sm">Something went wrong while looking up your account. Try again in a moment.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onRetry) {
    t3 = <Card className="overflow-hidden"><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t1}{t2}<Button onClick={onRetry} className="min-w-44">Try again</Button></CardContent></Card>;
    $[2] = onRetry;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export { DriveCheckErrorCard };